/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reconcile_Order_InternalInputs */

const vi_reconcile_order_internal = /** @type {(inputs: Reconcile_Order_InternalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nội bộ`)
};

/**

* @param {Reconcile_Order_InternalInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const reconcile_order_internal = /** @type {((inputs?: Reconcile_Order_InternalInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reconcile_Order_InternalInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_reconcile_order_internal(inputs)
});